import { createAction } from 'redux-actions';

export const updateChannelUnreadMessagesCount = createAction(
  'UPDATE_CHANNEL_UNREAD_MESSAGES_COUNT',
  channelsUnreadMessagesCount => ({ channelsUnreadMessagesCount }),
);
